import blog1 from "../img/21.jpg";
import blog2 from "../img/22.jpg";
import blog3 from "../img/23.jpg";
import blog4 from "../img/11.jpg";
import blog5 from "../img/7.jpg";
import blog6 from "../img/10.jpg";
import blog7 from "../img/24.jpg";
import blog8 from "../img/25.jpg";

const blogs = [
  {
    id: 1,
    image: blog1,
    title: "oświadczenie księdza Stefana Dziubiny",
    link: "http://www.beskid-niski.pl/index.php?pos=/lemkowie/kultura/nikifor2",
    date: "17-",
    month: "08-",
    year: "2003",
  },
  {
    id: 2,
    image: blog4,
    title: "Krynicki ostaniec. Rzecz o Nikiforze w reż. Wojciecha Markiewicza",
    link: "http://encyklopediateatru.pl/artykuly/4798/gdzie-jestescie-nikifory",
    date: "01-",
    month: "10-",
    year: "2004",
  },
  {
    id: 3,
    image: blog7,
    title: "Epifaniusz zwany Nikiforem - Michał Bołtryk",
    link: "http://archiwum.przegladprawoslawny.pl/articles.php?id_n=771&id=8",
    date: "30-",
    month: "12-",
    year: "2004",
  },
  {
    id: 4,
    image: blog5,
    title: "Zofia Kutszyńska o Nikiforze w art. Stanisława Śmierciaka",
    link: "https://www.nowysacz.pl/media-informuja/4112",
    date: "08-",
    month: "09-",
    year: "2005",
  },
  {
    id: 5,
    image: blog2,
    title: "O opiekunie prawnym Nikifora - Marianie Włosińskim",
    link:
      "http://bochnia.eu/plw%C5%82osi%C5%84ski-nikifor-chauchan-trojwystawa-w-muzeum",
    date: "28-",
    month: "01-",
    year: "2008",
  },
  {
    id: 6,
    image: blog3,
    title: "Ratujmy Nikifora. Herberta teksty interwencyjne",
    link:
      "https://teologiapolityczna.pl/joanna-adamowska-ratujmy-nikifora-herberta-teksty-interwencyjne",
    date: "08-",
    month: "10-",
    year: "2018",
  },

  {
    id: 7,
    image: blog6,
    title: "Artystyczne wędrówki Nikifora... Antoniego Adamskiego",
    link:
      "https://www.biznesistyl.pl/ludzie/sylwetki/6993_ikifora-do-rzeszowa,-krosna,-jasla-i-przemysla.html",
    date: "08-",
    month: "08-",
    year: "2019",
  },

  {
    id: 8,
    image: blog8,
    title: "Moje obrazy to rozmowy z Bogiem - Polskie Radio",
    link:
      "https://www.polskieradio.pl/39/156/Artykul/951247,Nikifor-Moje-obrazy-to-rozmowy-z-Bogiem",
    date: "10-",
    month: "10-",
    year: "2020",
  },
];

export default blogs;
